var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wp-items-view',{attrs:{"content-type":"ask-dwg-articles","content-type-singular":"ask-dwg-article","content-name":"Ask DWG articles","content-name-singular":"Ask DWG article"}})}
var staticRenderFns = []

export { render, staticRenderFns }